import { rgba } from 'polished';
import { schemeColor } from 'shared/assets/styles/scheme-color.style';
import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const ResizeHandle = styled.div<{ $position: 'start' | 'end' }>`
  position: absolute;
  top: 0;
  ${({ $position }) => ($position === 'start' ? 'left: 0' : 'right: 0')};

  display: flex;
  align-items: center;
  justify-content: center;

  width: 0.8rem;
  height: 100%;

  cursor: ew-resize;
  opacity: 0;
  transition: opacity 200ms;
`;

export const Bar = styled.div<{
  $left: number;
  $width: number;
  $color: string | null;
  $completed: boolean;
  $archived: boolean;
}>`
  position: absolute;
  top: 50%;
  left: ${({ $left }) => `${$left}px`};
  transform: translateY(-50%);

  display: flex;
  align-items: center;

  height: 3.2rem;
  width: ${({ $width }) => `${$width}px`};

  border-radius: ${({ theme }) => theme.spacing(1.5)};
  background: ${({ theme }) => theme.palette.background.default};
  box-shadow: 0 0 1px 1px ${({ theme }) => theme.palette.background.default};

  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: ${({ theme }) => theme.palette.grey[50]};
    border: 1px solid ${({ theme }) => theme.palette.grey[300]};
    border-radius: ${({ theme }) => theme.spacing(2)};
  }

  &:hover {
    ${ResizeHandle} {
      opacity: 1;
    }
  }

  ${({ $color, theme }) =>
    $color &&
    css`
      &:before {
        background: ${rgba(schemeColor($color, theme), 0.1)};
        border: 1px solid ${rgba(schemeColor($color, theme), 0.2)};
      }
    `};

  ${({ $completed }) =>
    $completed &&
    css`
      opacity: 0.5;
      text-decoration: line-through;
    `};

  ${({ $archived }) =>
    $archived &&
    css`
      opacity: 0.5;
    `};
`;

export const Content = styled.div`
  position: sticky;
  left: 0;

  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => `0 ${theme.spacing(2)}`};
`;

export const IconContainer = styled.div<{ $color: string | null }>`
  font-size: 1.6rem;
  line-height: 62.5%;

  ${({ $color, theme }) =>
    $color &&
    css`
      color: ${schemeColor($color, theme)};
    `};
`;

export const NameContainer = styled.div`
  ${({ theme }) => typographyToCss(theme.typography.subtitle2)};
  white-space: nowrap;
`;

export const ResizeIndicator = styled.div<{ $color: string | null }>`
  height: 1.4rem;
  width: 0.2rem;
  background: ${({ theme }) => theme.palette.grey[300]};
  border-radius: ${({ theme }) => theme.spacing(2)};

  ${({ $color, theme }) =>
    $color &&
    css`
      background: ${rgba(schemeColor($color, theme), 0.5)};
    `};
`;
